import { useCallback } from 'react';
import { Button, ButtonSizes, ButtonVariants, TableCellTypes } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import styles from './customerRowActions.module.scss';

/**
 * Props:
 *   row       the row the two links act on
 *   onEdit    (row) => void
 *   onDelete  (row) => void
 */
const EditDeleteActions = ({ row, onEdit, onDelete }) => {
  const t = useTranslations();
  const handleEdit = useCallback(() => onEdit(row), [onEdit, row]);
  const handleDelete = useCallback(() => onDelete(row), [onDelete, row]);

  return (
    <span className={styles.actions}>
      <Button variant={ButtonVariants.tertiary} size={ButtonSizes.sm} onClick={handleEdit}>
        {t('COMMON_EDIT')}
      </Button>
      <Button variant={ButtonVariants.tertiary} size={ButtonSizes.sm} onClick={handleDelete}>
        {t('COMMON_DELETE')}
      </Button>
    </span>
  );
};

// The inline Edit · Delete column both customer sub-tables end with.
export const buildEditDeleteColumn = (t, id, { onEdit, onDelete }) => {
  const renderActions = (ctx) => (
    <EditDeleteActions row={ctx.row} onEdit={onEdit} onDelete={onDelete} />
  );
  return {
    id,
    header: t('FIELD_ACTION'),
    type: TableCellTypes.custom,
    width: 160,
    isActions: true,
    reorderable: false,
    resizable: false,
    cell: renderActions,
  };
};
